import { useState } from "react";
import { Button } from "antd";
import { useParams } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { memberState } from "../../state/atoms";
import { ListingsHomeTab } from "../listings/ListingsHomeTab";
import { ListingsListingsTab } from "../listings/ListingsListingsTab";
import { ListingsProfileTab } from "../listings/ListingsProfileTab";
import { ListingsSplash } from "../listings/ListingsSplash";
import "./Listings.scss";

type ListingsTabKey = "home" | "listings" | "reports" | "profile";

const TABS: { key: ListingsTabKey; label: string }[] = [
  { key: "home", label: "Home" },
  { key: "listings", label: "Listings" },
  { key: "reports", label: "Reports" },
  { key: "profile", label: "Profile" },
];

// TODO: derive from real listings license/subscription state once the backend exists.
// When the member has no Business Listings subscription, show the splash instead of the dashboard.
const HAS_LISTINGS_SUBSCRIPTION = true;

export default function Listings() {
  const [activeTab, setActiveTab] = useState<ListingsTabKey>("home");
  const member = useRecoilValue(memberState);
  const { locationId } = useParams();

  function onAddBusinessListings() {
    // Opens the shared payment modal (Add Business Listings add-on flow).
    window.MHM.ProModal.addListings({
      memberId: `${member.ownerId}` || member.id,
      locationId: locationId ? Number(locationId) : undefined,
      onSuccess: () => window.location.reload(),
    });
  }

  if (!HAS_LISTINGS_SUBSCRIPTION) {
    return (
      <div className="listings-page">
        <ListingsSplash onAddBusinessListings={onAddBusinessListings} />
      </div>
    );
  }

  return (
    <div className="listings-page">
      <header className="listings-page-header">
        <h1>Listings</h1>
        <Button type="primary" className="listings-order-btn" onClick={onAddBusinessListings}>
          Order
        </Button>
      </header>

      <nav className="listings-tabs">
        {TABS.map((t) => (
          <button
            key={t.key}
            type="button"
            className={`listings-tab${activeTab === t.key ? " active" : ""}`}
            onClick={() => setActiveTab(t.key)}
          >
            {t.label}
          </button>
        ))}
      </nav>

      <div className="listings-tab-content">
        {activeTab === "home" && <ListingsHomeTab locationId={locationId ? Number(locationId) : undefined} />}
        {activeTab === "listings" && <ListingsListingsTab />}
        {activeTab === "reports" && <div className="listings-placeholder">Reports — coming soon</div>}
        {activeTab === "profile" && <ListingsProfileTab />}
      </div>
    </div>
  );
}
